"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BeginYourCelebration() {
  return <section id="begin-your-celebration" className="dark bg-primary text-primary-foreground py-20 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558956/img/stucco.png')] opacity-10 mix-blend-overlay pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12 space-y-4">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight drop-shadow-sm">Estamos para servirles por todo Indianapolis!</h2>
          
        </div>

        <div className="w-full h-[450px] md:h-[550px] rounded-xl overflow-hidden shadow-2xl border border-white/10 bg-card/50 backdrop-blur-sm">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d196238.15112528352!2d-86.27283287315132!3d39.77978446194723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b50ffa7796a03%3A0xd68e9df57e5df036!2sIndianapolis%2C%20IN!5e0!3m2!1sen!2sus!4v1710182400000!5m2!1sen!2sus" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Indianapolis Location Map" className="w-full h-full opacity-90 hover:opacity-100 transition-opacity duration-300" />
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="bg-white text-primary hover:bg-white/90 font-semibold px-10 py-6 text-lg rounded-sm shadow-lg transition-all hover:translate-y-[-2px] active:scale-95">
            <Link to="https://form.jotform.com/260726417957063" newTab>Ordenen Aqui </Link>
          </Button>
        </div>
      </div>
    </section>;
}